import React, { useEffect, useRef, useState } from 'react';
import PreviewArticle from './components/PreviewArticle';
import useQuery from '../../../util/useQuery';
import CCTVPolicyService from '../../../services/CCTVPolicy.service';
import GlobalService from '../../../services/Global.service';
import { sendHeightToIframe } from '../sendHeight';

export default function ViewCCTV() {
    const params = useQuery();
    const id = params.get('id');
    const lang = params.get('lang');

    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const [logo, setLogo] = useState('');
    const ref = useRef();

    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(
                companyLogoId
            );
            if (data.resultData?.imageId) {
                setLogo(`data:image/png;base64,${data.resultData?.imageId}`);
            } else {
                setLogo('');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getNoSecurePublishedVersion = async () => {
            try {
                const { data } =
                    await CCTVPolicyService.getNoSecurePublishedVersion(id);
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetail(parse);
                    setLoading(false);
                    setLogo('');
                    if (parse?.cctvPolicy?.cctvCompanyLogoId) {
                        getImage(parse?.cctvPolicy?.cctvCompanyLogoId);
                    }

                    sendHeightToIframe(ref.current);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (id) {
            getNoSecurePublishedVersion();
        }
        document.body.style.background = 'transparent';
    }, [id]);

    return (
        <div ref={ref}>
            <PreviewArticle
                logo={logo}
                lang={lang}
                detail={detail}
                loading={loading}
                mode="view"
            />
        </div>
    );
}
